import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { NewsPage } from "./NewsPage";

export const news = typeCheckAppModule({
    NAME: "news",
    Container: NewsPage,
    route: Routes.news,
});
